
export default {
    name: 'LeeCollapse',
    inheritAttrs: false,
    data() {
        return {

        }
    },
    provide() {
        return {
            collapse: this
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.$emit('change',value)
            }
        }
    },
    props: {
        value:[String,Array],
        accordion: {
            type: Boolean,
            default:false
        }
    }
};
